<template>
    <b-row>
      <b-col md="12" lg="12" class="bg-heart">
          <p>
          <base-button white shadow class="ml-4 btn1"
              @click="getOpensaludpass()">
              {{ button_text }}
            </base-button>
            </p>
            <p>
            <base-button blue href="/"><span>{{ $t('bgheart.more-info-btn') }}</span> <base-icon src="/static-appopensalud/img/icons/morillas-svg-icons/primary/arrow.svg" class="ml-2" color="white"/></base-button>
            </p>
      </b-col>
    </b-row>
</template>

<script>
  import es from '@/lang/es/public/views/primesalud-discounts.json'
  import en from '@/lang/en/public/views/primesalud-discounts.json'
  import opensaludprimeMixin from '@/mixins/opensaludprime.mixin'

  export default {
  mixins: [opensaludprimeMixin],
  i18n: {
    messages: {
      es,
      en,
      mx: es
    }
  },
  props: {
    title: {
      type: String,
      default () {
        return this.$t('header-title')
      }
    },
    subtitle: {
      type: String,
      default () {
        return this.$t('upper-header-subtitle')
      }
    },
    button_text: {
      type: String,
      default () {
        return this.$t('bgheart.hire-now-with-price')
      }
    },
    label_text: {
      type: String,
      default () {
        return this.$t('learn-more-btn')
      }
    }
  },
  methods: {
    buy () {
      this.$helpers.goToWebApp(
        '#dlgRegisterPatient?returnUrl=/HomePaciente#/profile/addsubscription/opensaludpass'
      )
    }
  }
}
</script>

<style lang="scss">
  @import "../../../static-appopensalud/css/public/layout.scss";

.shadow-btn{
  max-width: 19rem;
}
  #medic-assistance-prof .col-bg {
    background-image: url(/static-appopensalud/img/bgs/medical-assistance-professionals.png),
      linear-gradient(273deg, #ffffff96, transparent);
    background-position: center;
    background-blend-mode: overlay;
    
  }

    .bg-heart{
    animation: heartbeat 2s infinite, fade-in 2s ease-in;
    background-image: url('/static-appopensalud/img/icons/morillas-svg-icons/primary/NEU_BigHeart.svg');
    background-position: center;
    background-repeat: no-repeat;
    width: 100%;
    height: 90vh;
    display: block;
    margin: 0px 0px 0px 0%;
    padding-top:36vh;
  }

@keyframes heartbeat
{
  0%
  {
    background-size: 63%;
  }
  20%
  {
    background-size: 60%;
  }
  40%
  {
    background-size: 63%;
  }
  60%
  {
    background-size: 60%;
  }
  80%
  {
    background-size: 63%;
  }
  100%
  {
    background-size: 63%;
  }
}

@keyframes fade-in
{
  0%
  {
    opacity: 0%;
  }
  100%
  {
    opacity: 100%;
  }
}

  .title h3{
        font-size: 3em;
    }
    .logorec{
        padding-top: 2em;
        text-align: center;
    }
  @media (max-width: 1268px) {
    #medic-assistance
      > div.content.my-auto.col-md-12.col-lg-6
      > div
      > div
      > div
      > p {
      font-size: 1rem;
    }
    
  }
</style>


// WEBPACK FOOTER //
// src/components/public/BgHeartButtonsDiscount.vue